import { useState } from 'react';
import { NavLink, Outlet, useNavigate } from 'react-router-dom';
// ─── Définition des onglets ──────────────────────────────────────────────────
const ONGLETS = [
  { id: 'commandes',  label: 'Commandes',  emoji: '📋', role: 'commandes' },
  { id: 'pilotes',    label: 'Pilotes',    emoji: '👤', role: 'pilotes' },
  { id: 'produits',   label: 'Produits',   emoji: '📦', role: 'produits' },
  { id: 'operateurs', label: 'Opérateurs', emoji: '🔧', role: 'operateurs' },
  { id: 'profils',    label: 'Profils',    emoji: '🎫', role: 'profils' },
];

// ─── Couleurs ────────────────────────────────────────────────────────────────
const BLEU = '#003189';
const BLEU_FONCE = '#00236b';

// ─── Composant ───────────────────────────────────────────────────────────────
export default function FFMPortalLayout({ session, onLogout }) {
  const navigate = useNavigate();
  const [sidebarOpen, setSidebarOpen] = useState(true);

  const roles = session?.roles || [];
  const isAdmin = roles.includes('admin');

  // Filtre les onglets selon les rôles
  const ongletsFiltres = ONGLETS.filter(
    (o) => isAdmin || roles.includes(o.role)
  );

  const handleLogout = () => {
    localStorage.removeItem('ffm_session');
    if (onLogout) onLogout();
    navigate('/ffm-customlab/login');
  };

  return (
    <div style={{ display: 'flex', minHeight: '100vh', fontFamily: "'Segoe UI', system-ui, -apple-system, sans-serif" }}>

      {/* ── Sidebar ────────────────────────────────────────────────────────── */}
      <aside style={{
        width: sidebarOpen ? '240px' : '64px',
        minWidth: sidebarOpen ? '240px' : '64px',
        backgroundColor: BLEU,
        display: 'flex',
        flexDirection: 'column',
        transition: 'width 0.25s ease, min-width 0.25s ease',
        position: 'fixed',
        top: 0,
        left: 0,
        bottom: 0,
        zIndex: 100,
        overflow: 'hidden',
      }}>

        {/* Logo FFM */}
        <div style={{
          padding: sidebarOpen ? '24px 20px' : '16px 10px',
          borderBottom: '1px solid rgba(255,255,255,0.12)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: sidebarOpen ? 'flex-start' : 'center',
          gap: '12px',
          minHeight: '80px',
        }}>
          <img
            src="/Image/Logo FFM blanc.png"
            alt="FFM"
            style={{
              height: sidebarOpen ? '64px' : '44px',
              objectFit: 'contain',
              flexShrink: 0,
            }}
          />
          {sidebarOpen && (
            <div>
              <p style={{ color: '#fff', fontWeight: '700', fontSize: '14px', margin: 0, letterSpacing: '0.3px' }}>
                Custom Lab FFM
              </p>
              <p style={{ color: 'rgba(255,255,255,0.5)', fontSize: '11px', margin: 0, marginTop: '2px' }}>
                Espace de gestion
              </p>
            </div>
          )}
        </div>

        {/* Navigation */}
        <nav style={{ flex: 1, padding: '16px 0', overflowY: 'auto' }}>
          {ongletsFiltres.map((o) => (
            <NavLink
              key={o.id}
              to={`/ffm-customlab/dashboard/${o.id}`}
              style={({ isActive }) => ({
                display: 'flex',
                alignItems: 'center',
                gap: '12px',
                padding: sidebarOpen ? '11px 20px' : '11px',
                justifyContent: sidebarOpen ? 'flex-start' : 'center',
                textDecoration: 'none',
                color: isActive ? '#ffffff' : 'rgba(255,255,255,0.65)',
                backgroundColor: isActive ? BLEU_FONCE : 'transparent',
                borderLeft: isActive ? '3px solid #ffffff' : '3px solid transparent',
                fontWeight: isActive ? '600' : '400',
                fontSize: '14px',
                transition: 'all 0.15s ease',
                cursor: 'pointer',
              })}
              onMouseEnter={(e) => {
                e.currentTarget.style.backgroundColor = BLEU_FONCE;
                e.currentTarget.style.color = '#ffffff';
              }}
              onMouseLeave={(e) => {
                // Le NavLink reset via style callback, on force via className trick
                // Simple hover : on laisse le style dynamique gérer
              }}
            >
              <span style={{ fontSize: '16px', flexShrink: 0 }}>{o.emoji}</span>
              {sidebarOpen && <span>{o.label}</span>}
            </NavLink>
          ))}
        </nav>

        {/* Bouton Aide */}
        <div style={{ padding: sidebarOpen ? '0 20px 12px' : '0 8px 12px' }}>
          <NavLink
            to="/ffm-customlab/dashboard/aide"
            style={({ isActive }) => ({
              display: 'flex',
              alignItems: 'center',
              gap: '8px',
              justifyContent: sidebarOpen ? 'flex-start' : 'center',
              background: isActive ? 'rgba(255,255,255,0.15)' : 'rgba(255,255,255,0.08)',
              border: '1px solid rgba(255,255,255,0.15)',
              borderRadius: '8px',
              color: 'rgba(255,255,255,0.75)',
              padding: sidebarOpen ? '8px 14px' : '8px',
              textDecoration: 'none',
              fontSize: '13px',
              fontWeight: '500',
              transition: 'background 0.15s',
              width: '100%',
              boxSizing: 'border-box',
            })}
            onMouseEnter={(e) => (e.currentTarget.style.background = 'rgba(255,255,255,0.15)')}
            onMouseLeave={(e) => (e.currentTarget.style.background = 'rgba(255,255,255,0.08)')}
          >
            <span>❓</span>
            {sidebarOpen && <span>Aide & Guide</span>}
          </NavLink>
        </div>

        {/* Profil + déconnexion */}
        <div style={{
          borderTop: '1px solid rgba(255,255,255,0.12)',
          padding: sidebarOpen ? '16px 20px' : '12px',
        }}>
          {sidebarOpen && session && (
            <div style={{ marginBottom: '12px' }}>
              <p style={{ color: '#fff', fontWeight: '600', fontSize: '13px', margin: 0 }}>
                {session.prenom} {session.nom}
              </p>
              <p style={{ color: 'rgba(255,255,255,0.45)', fontSize: '11px', margin: '2px 0 0' }}>
                {session.email}
              </p>
            </div>
          )}
          <button
            onClick={handleLogout}
            title="Déconnexion"
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: '8px',
              justifyContent: sidebarOpen ? 'flex-start' : 'center',
              background: 'rgba(255,255,255,0.08)',
              border: '1px solid rgba(255,255,255,0.15)',
              borderRadius: '8px',
              color: 'rgba(255,255,255,0.75)',
              padding: sidebarOpen ? '8px 14px' : '8px',
              cursor: 'pointer',
              width: '100%',
              fontSize: '13px',
              fontWeight: '500',
              transition: 'background 0.15s',
            }}
            onMouseEnter={(e) => (e.currentTarget.style.background = 'rgba(255,255,255,0.15)')}
            onMouseLeave={(e) => (e.currentTarget.style.background = 'rgba(255,255,255,0.08)')}
          >
            <span>🚪</span>
            {sidebarOpen && <span>Déconnexion</span>}
          </button>
        </div>

        {/* Bouton toggle sidebar */}
        <button
          onClick={() => setSidebarOpen(!sidebarOpen)}
          title={sidebarOpen ? 'Réduire' : 'Agrandir'}
          style={{
            position: 'absolute',
            top: '24px',
            right: '-12px',
            width: '24px',
            height: '24px',
            borderRadius: '50%',
            backgroundColor: '#ffffff',
            color: BLEU,
            border: `2px solid ${BLEU}`,
            cursor: 'pointer',
            fontSize: '10px',
            fontWeight: '700',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            boxShadow: '0 2px 6px rgba(0,0,0,0.2)',
            zIndex: 10,
          }}
        >
          {sidebarOpen ? '◀' : '▶'}
        </button>
      </aside>

      {/* ── Zone principale ────────────────────────────────────────────────── */}
      <main style={{
        flex: 1,
        marginLeft: sidebarOpen ? '240px' : '64px',
        transition: 'margin-left 0.25s ease',
        display: 'flex',
        flexDirection: 'column',
        minHeight: '100vh',
        backgroundColor: '#F4F6FA',
      }}>

        {/* Topbar */}
        <header style={{
          backgroundColor: '#ffffff',
          borderBottom: '1px solid #D0D8EE',
          padding: '0 28px',
          height: '60px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          position: 'sticky',
          top: 0,
          zIndex: 50,
          boxShadow: '0 1px 4px rgba(0,49,137,0.06)',
        }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
            <div style={{
              width: '4px',
              height: '24px',
              backgroundColor: BLEU,
              borderRadius: '2px',
            }} />
            <span style={{ fontWeight: '600', color: '#1a1a2e', fontSize: '15px' }}>
              Fédération Française de Motocyclisme — Personnalisation des équipes de France
            </span>
          </div>
          <img
            src="/Image/Logo Moto France.png"
            alt="Moto France"
            style={{ height: '52px', objectFit: 'contain', opacity: 0.9 }}
          />
        </header>

        {/* Contenu — les pages s'affichent ici via <Outlet /> */}
        <div style={{ flex: 1, padding: '28px' }}>
          <Outlet context={{ session }} />
        </div>
      </main>
    </div>
  );
}
